module.exports = __webpack_public_path__ + "static/media/cloud-dropbox-icon.91ed55b3.svg";